<template>
    <MobileView></MobileView>
</template>

<script>
import { defineAsyncComponent } from "vue";

const GuestLayout = defineAsyncComponent(() =>
    import("../../Layouts/GuestLayout.vue")
);
const MobileView = defineAsyncComponent(() =>
    import("../../components/Safety/Mobile/MobileView.vue")
);

export default {
    name: "Mobile_View", //The name you are in should not equal the name of the component you are importing.
    components: { MobileView, GuestLayout },
    layout: [GuestLayout],
};
</script>
